import { deserialize, DocumentObject, serialize } from '@jsonapiworld/jsonapi-serializer';
import { backendApiGateway } from '~/client/backend';
import { Company } from '~/types/company';
import { CompanySettings } from '~/types/company-settings';

export const createCompanySettings = async (
  companyId: Company['id'],
  settings: Partial<CompanySettings>,
): Promise<CompanySettings> => {
  const payload = serialize({ ...settings, company: { id: companyId } }, 'company-settings', {
    relationships: ['company'],
  });
  const { data } = await backendApiGateway.post<DocumentObject>('/api/v1/company-settings/', payload);
  const deserialized = deserialize<CompanySettings>(data) as CompanySettings;
  return deserialized;
};

export const updateCompanySettings = async (
  companySettingsId: CompanySettings['id'],
  settings: Partial<CompanySettings>,
): Promise<CompanySettings> => {
  const payload = serialize(
    {
      id: companySettingsId,
      ...settings,
    },
    'company-settings',
  );

  const { data } = await backendApiGateway.patch<DocumentObject>(
    `/api/v1/company-settings/${companySettingsId}`,
    payload,
  );
  return deserialize<CompanySettings>(data) as CompanySettings;
};
